import "./ArcadiaPestControl.module.css";
import Header from "@/reusable_sections/Header";
import ArcadiaPestControlHero from "./sections/ArcadiaPestControlHero";
import ArcadiaPestProblems from "./sections/ArcadiaPestProblems";
import ArcadiaPestServices from "./sections/ArcadiaPestServices";
import PestControlProcess from "./sections/PestControlProcess";
import ServiceInclusions from "./sections/ServiceInclusions";
import WhyChoosePeaceRiver from "./sections/WhyChoosePeaceRiver";
import ArcadiaPestPressureAnalysis from "./sections/ArcadiaPestPressureAnalysis";
import ArcadiaFreeInspectionCta from "./sections/ArcadiaFreeInspectionCta";
import ArcadiaPestFAQ from "./sections/ArcadiaPestFAQ";
import Footer from "@/reusable_sections/Footer";
export default function ArcadiaPestControlPage() {
  return <div>
      <Header />
      <ArcadiaPestControlHero />
      <ArcadiaPestProblems />
      <ArcadiaPestServices />
      <PestControlProcess />
      <ServiceInclusions />
      <WhyChoosePeaceRiver />
      <ArcadiaPestPressureAnalysis />
      <ArcadiaPestFAQ />
      <ArcadiaFreeInspectionCta />
      <Footer />
    </div>;
}